import { createDynamicQueryResource } from '@subtile/project-shared';
import type { Accessor } from 'solid-js';
import document, { type AccountTransfersVars } from '../queries/accountTransfersQuery';
import type { AccountTransfers } from '../types';

export default (variables: Accessor<AccountTransfersVars | null>) =>
  createDynamicQueryResource<AccountTransfers, AccountTransfersVars>(document, variables);
